import axios from "axios";
import { Auth } from "aws-amplify";
// import { EXPIRED } from "../auth/actions";

import Config from "../../../../config";

axios.defaults.headers.common["Content-Type"] =
  "application/json;charset=UTF-8";

export const get_assets = (data) => {
  return Auth.currentSession()
    .then((session) => {
      const token = session && session.idToken.jwtToken;

      var config = { headers: { Authorization: "Bearer " + token } };

      var queryString = Object.keys(data)
        .map((key) => key + "=" + data[key])
        .join("&");

      return axios
        .get(
          `${Config.API_BASE_URL}/v2/client-project/Asset?${queryString}`,
          config
        )
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          return false;
        });
    })
    .catch((error) => {
      // dispatch({ type: EXPIRED });
    });
};
